'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { assertPropDefined } from '../utils/PropValidationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IndexErrorState = ({
  FailureMarker
}) => {
  assertPropDefined(FailureMarker, 'FailureMarker');
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(FailureMarker, {}), /*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      width: 150,
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx("h2", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.errorState.errorTitle"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.errorState.errorDescription"
      })
    })]
  });
};
IndexErrorState.propTypes = {
  FailureMarker: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};
export default IndexErrorState;